import { Island } from '../island.class';
/**
 * Calculates island baseSize bsaed on island type. Base size represents the outside dimensions and do not include countertop overhangs
 * @param island Island to calculate the base size for
 * @returns Size
 */
export const getTotalMsrpCfn = (island: Island): number => {
	const itemized = island.msrpItemized;
	const itemsTotal = itemized.items.reduce((acc, item) => acc + item.total, 0);

	return itemized.countertop.total + itemized.island + itemsTotal;
};
